import DatabaseModel from './DatabaseModel.js';

var CuentaBancaria = Object.create(DatabaseModel);

CuentaBancaria.model = 'cuentasbancarias';
CuentaBancaria.modelFront = 'cuentasbancarias';

export default CuentaBancaria;